import {
  ActionIcon,
  Box,
  Flex,
  Group,
  Image,
  Loader,
  Stack,
  Text,
} from '@mantine/core';
import { Dropzone, FileWithPath, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import { ReactNode } from 'react';
import { IconPhoto, IconTrash, IconUpload, IconX } from '@tabler/icons-react';
import { ImageField } from './imageUploadField';

export type ImageUploadOps = {
  remove: () => void;
  upload: (file: File) => void;
  preview: string | null;
  kind: ImageField['kind'];
};

export function MessageImageUpload({
  upload,
  preview,
  remove,
  disabled = false,
  error,
  isLoading = false,
}: ImageUploadOps & {
  disabled?: boolean;
  error?: ReactNode | undefined;
  isLoading?: boolean;
}) {
  const handleDrop = (files: FileWithPath[]) => {
    if (disabled || files.length === 0) return;
    upload(files[0]);
  };

  const content = (() => {
    if (isLoading) {
      return <Loader color="blue" />;
    }

    if (preview) {
      return (
        <Flex
          justify="center"
          wrap="nowrap"
          className="relative overflow-clip h-full w-full"
        >
          {/* <UnstyledButton className="absolute top-2 right-2 z-10"> */}
          <ActionIcon
            variant="filled"
            color="red"
            className="absolute top-2 right-2 z-10"
            onClick={remove}
            style={{ position: 'absolute' }}
          >
            <IconTrash />
          </ActionIcon>
          {/* </UnstyledButton> */}
          <Image
            src={preview}
            alt="notification"
            radius="sm"
            fit="cover"
            className="h-full w-full border border-gray-300"
          />
        </Flex>
      );
    }

    return (
      <Group justify="center" p="md">
        <Dropzone
          onDrop={handleDrop}
          maxFiles={1}
          maxSize={3 * 1024 ** 2}
          accept={IMAGE_MIME_TYPE}
          disabled={disabled}
        >
          <Dropzone.Accept>
            <IconUpload size={20} />
          </Dropzone.Accept>
          <Dropzone.Reject>
            <IconX size={20} />
          </Dropzone.Reject>
          <Dropzone.Idle>
            <Group gap={8}>
              <IconPhoto size={20} />
              <Text size="sm">拖曳圖片到此處，或點擊上傳</Text>
            </Group>
          </Dropzone.Idle>
        </Dropzone>
      </Group>
    );
  })();

  return (
    <Stack gap={8}>
      <Box
        className="h-50 flex justify-center items-center"
        style={{
          borderColor: error
            ? 'var(--mantine-color-red-5)'
            : 'var(--mantine-color-gray-4)',
        }}
      >
        {content}
      </Box>
      {error && (
        <Text size="xs" c="red">
          {error}
        </Text>
      )}
    </Stack>
  );
}
